import { useCallback, useEffect, useState } from "react";
import { MessageAnt } from "../../../../redux/slices/ui/uiAction";
import { MessageType } from "../../../../types/messageType";
import { getRequestProjectDetailsEntriesV2 } from "../../../../config";
import { getDataReduxProjectDetails } from "../../../../helpers/helperDetailsBySpace";
import { useLocation, useParams } from "react-router-dom";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

export const useProjectDetails = () => {
    const { id } = useParams();
    const query = useQuery();
    const [isLoading, setIsLoading] = useState(true);
    const [errorPage, setErrorPage] = useState(false)
    const [projectDetails, setProjectDetails] = useState({})

    const getErrorProject = useCallback(() => {
        setErrorPage(true)
        MessageAnt(MessageType.error, `Error de obtener el proyecto`);
    }, []);

    const getProjectDetails = useCallback(
        async (spaceId = -1) => {
            if (spaceId === -1) return;

            const { status, payload } = await getRequestProjectDetailsEntriesV2(spaceId);
            if (status > 0) return getErrorProject();

            const getData = getDataReduxProjectDetails(payload);
            if (!getData) return getErrorProject();

            setProjectDetails(getData)
            setErrorPage(false)

        },
        [getErrorProject]
    );

    useEffect(() => {
        setIsLoading(true);
        getProjectDetails(id)
            .finally(() => setIsLoading(false));
    }, [getProjectDetails, id]);

    return {
        isLoading,
        query,
        errorPage,
        project: projectDetails,
        getProjectDetails
    };
};
